module.exports = __webpack_public_path__ + "img/copy.ccfea5e7.svg";